// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__0aefI","loader":"Loader_loader__Iuf6t","spin":"Loader_spin__xSLwg"};